var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundClear(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M18.87 5.325c-.201-.201-.474-.315-.759-.315-.284 0-.557.114-.758.315l-5.261 5.25-5.26-5.26c-.272-.272-.667-.378-1.037-.278-.37.099-.66.388-.758.758-.1.37.006.765.277 1.036l5.261 5.261-5.26 5.26c-.272.272-.378.667-.278 1.037.099.37.388.66.758.759.37.099.765-.007 1.036-.278l5.261-5.261 5.26 5.26c.272.272.667.378 1.037.279.37-.1.66-.389.759-.759.099-.37-.007-.765-.278-1.036l-5.261-5.261 5.26-5.26c.41-.41.41-1.098 0-1.507z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundClear);
export default __webpack_public_path__ + "static/media/round-clear.7d74b941.svg";
export { ForwardRef as ReactComponent };